import { Box, Chip, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppCustomStyles } from "../../../assets/theme/custom/hooks";

type Props = {
  nodeCount: number;
  edgeCount: number;
  staleCount: number;
  incompleteEdgeCount: number;
  validationErrors: string[];
  lastValidatedAt?: string | null;
};

export default function PrepDesignStatusBar({
  nodeCount,
  edgeCount,
  staleCount,
  incompleteEdgeCount,
  validationErrors,
  lastValidatedAt,
}: Props) {
  const { t } = useTranslation();
  const custom = useAppCustomStyles();
  const hasErrors = validationErrors.length > 0;

  return (
    <Box
      sx={custom.components.dataPrep.statusBar}
    >
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
        <Typography variant="caption" color="text.secondary">
          {t("prep.statusBar.nodes", { count: nodeCount })} · {t("prep.statusBar.edges", { count: edgeCount })}
        </Typography>
        {staleCount > 0 && (
          <Chip size="small" color="warning" label={t("prep.statusBar.stale", { count: staleCount })} />
        )}
        {incompleteEdgeCount > 0 && (
          <Chip size="small" color="warning" variant="outlined" label={t("prep.statusBar.incompleteEdges", { count: incompleteEdgeCount })} />
        )}
        {hasErrors ? (
          <Chip size="small" color="error" label={t("prep.statusBar.invalid", { count: validationErrors.length })} />
        ) : lastValidatedAt ? (
          <Chip size="small" color="success" variant="outlined" label={t("prep.statusBar.valid")} />
        ) : null}
        {hasErrors && (
          <Typography variant="caption" color="error.main" sx={custom.components.dataPrep.statusBarErrorText} noWrap title={validationErrors.join("; ")}>
            {validationErrors[0]}
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
